import React from 'react';
import { LiferayService } from "../../../common/services/liferay/index";
import { decode_utf8, getSignedIdStatus } from "../../../common/utils/utilsFunc"
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";

export const RecoverPasswordContext = React.createContext();

export const ACTIONS = {
    SET_ERROR:"SET_ERROR",
    SET_FORGOT_PASSWORD: "SET_FORGOT_PASSWORD",
    SET_FORGOT_PASSWORD_RESPONSE: "SET_FORGOT_PASSWORD_RESPONSE",
    SET_CONFIRM_FORGOT_PASSWORD: "SET_CONFIRM_FORGOT_PASSWORD",
    SET_CONFIRM_FORGOT_PASSWORD_RESPONSE: "SET_CONFIRM_FORGOT_PASSWORD_RESPONSE",

};

const initialState = {
    error: null,
    forgotPassword: null,
    forgotPasswordResponse: null,
    confirmForgotPassword: null,
    confirmForgotPasswordResponse: null,

};

const RecoverPasswordReducer = (state = initialState, action) => {

    switch (action.type){
        case ACTIONS.SET_FORGOT_PASSWORD: {
            return {
                ...state,
                forgotPassword: action.payload
            };
        }
        case ACTIONS.SET_FORGOT_PASSWORD_RESPONSE: {
            return {
                ...state,
                forgotPasswordResponse: action.payload
            };
        }
        case ACTIONS.SET_CONFIRM_FORGOT_PASSWORD: {
            return {
                ...state,
                confirmForgotPassword: action.payload
            };
        }
        case ACTIONS.SET_CONFIRM_FORGOT_PASSWORD_RESPONSE: {
            return {
                ...state,
                confirmForgotPasswordResponse: action.payload
            };
        }
        default: {
            return state;
        }
    }

};

const RecoverPasswordContextProvider = ({children}) => {
    const properties = React.useContext(ApplicationPropertiesContext);
    const [state, dispatch] = React.useReducer(RecoverPasswordReducer, initialState);


    React.useEffect(() => {
        if(state.confirmForgotPassword){
            LiferayService.awsConfirmForgotPassword(properties.base_url_api, state.confirmForgotPassword)
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_CONFIRM_FORGOT_PASSWORD_RESPONSE,
                })
                dispatch({
                  payload: null,
                  type: ACTIONS.SET_CONFIRM_FORGOT_PASSWORD,
                });
                dispatch({
                    payload: null,
                    type: ACTIONS.SET_ERROR,
                });
            })
            .catch((error) => {
                dispatch({
                payload: error.message,
                type: ACTIONS.SET_ERROR,
                });
            })
        }
    },[state.confirmForgotPassword])

    React.useEffect(() => {
        if(state.forgotPassword){
            LiferayService.awsForgotPassword(properties.base_url_api, state.forgotPassword)
            .then((response) => {
                dispatch({
                    payload: response,
                    type: ACTIONS.SET_FORGOT_PASSWORD_RESPONSE,
                })
                dispatch({
                  payload: null,
                  type: ACTIONS.SET_FORGOT_PASSWORD,
                });
                dispatch({
                    payload: null,
                    type: ACTIONS.SET_ERROR,
                });
            })
            .catch((error) => {
                dispatch({
                payload: error.message,
                type: ACTIONS.SET_ERROR,
                });
            })
        }
    },[state.forgotPassword])

    return (
        <RecoverPasswordContext.Provider value={[state, dispatch]}>
            {children}
        </RecoverPasswordContext.Provider>

    )
}

export default RecoverPasswordContextProvider;